import React, { cloneElement } from 'react';
import { connect } from 'react-redux';

import { getIsAppConnected } from '../../selectors/applications';

class AppsContainer extends React.Component {
  // static propTypes = {
  //   apps: PropTypes.object.isRequired,
  //   children: PropTypes.element.isRequired,
  //   isSubscribed: PropTypes.bool.isRequired,
  //   isLoading: PropTypes.bool.isRequired,
  //   project_name: PropTypes.string.isRequired,
  // };


  render() {
    const { children, apps, isLoading, isSubscribed, project_name } = this.props;
    return cloneElement(children, { apps, isLoading, isSubscribed, project_name });
    // isSubscribed не используется в проходах. TODO убрать отсюда
  }
}

const mapStateToProps = (state, ownProps) => {
  const { params: { id }, location: { pathname } } = ownProps;
  const studentId = parseInt(id, 10);
  const type = pathname.split('/')[3];
  return ({
    currentStudent: state.settings.current.id,
    isLoading: state.apps.opts.loading || state.students.loading,
    isSubscribed: getIsAppConnected(state, { id: studentId, app: type }),
    apps: state.apps,
    project_name: state.dealer.project_name,
  });
};


export default connect(mapStateToProps)(AppsContainer);
